module.exports = __webpack_public_path__ + "static/media/mesh_verification.b95991d2.png";